import { createContext, useState } from 'react';
import api from 'services/api';

export const ProdutosContext = createContext();

export const ProdutosProvider = ({ children }) => {
  const [getLoading, setGetLoading] = useState(false);
  const [postLoading, setPostLoading] = useState(false);

  const postEtiquetas = async ({ data, cb }) => {
    try {
      setPostLoading(true);
      await api.post('/Cadastros/Produto/Etiquetas', data);
      if (cb) {
        cb();
      }
    } catch (error) {
    } finally {
      setPostLoading(false);
    }
  };

  const getProduto = async ({ id, cb }) => {
    try {
      setGetLoading(true);
      const params = { Descricao: true };
      const { data } = await api.get(`/Cadastros/Produto/${id}`, { params });
      if (cb) {
        cb(data);
      }
    } catch (error) {
    } finally {
      setGetLoading(false);
    }
  };

  return (
    <ProdutosContext.Provider
      value={{ postEtiquetas, postLoading, getProduto, getLoading }}
    >
      {children}
    </ProdutosContext.Provider>
  );
};
